<script>
	import { goto } from "@roxi/routify";
	import { postFormData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	let loginForm;
	let oldPasswordError = '';
	let newPasswordError = '';
	let checkNewPasswordError = '';
	// handle login form submission and response
	function handleChangePassword() {
		let res = postFormData('user/edit-password', loginForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('/dashboard');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				console.log(errors);
				oldPasswordError = errors.old_password ? errors.old_password[0] : '';
				newPasswordError = errors.new_password ? errors.new_password[0] : '';
				checkNewPasswordError = errors.check_new_password ? errors.check_new_password[0] : '';
			}
		});
	}
</script>

<main class=background>
	<Navbar/>
	<div class="lg:mx-64 md:mx-32 sm:mx-10 mx-2 pb-20">
		<div class="mx-auto mt-10">
			<div class="max-w-xl mx-auto p-16 rounded-md shadow-lg bg-white bg-opacity-50">
				<p class="text-2xl font-semibold text-blue-900 mb-8">Change Password</p>
				<form method="POST" class="flex-col h-full relative box-border" bind:this={loginForm} on:submit|preventDefault={handleChangePassword}>
					<div class="flex flex-col space-y-6 text-xl h-full box-border">
						<div class='input'>
							<div class="relative">
								<input id="old-password" name="old_password" type="password" placeholder="Old Password" class="peer z-20 placeholder:text-transparent {oldPasswordError === '' ? '' : 'border-red-600'}"/>
								<label for="old-password" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Old Password</label>
							</div>
							<p class='error-text {oldPasswordError === '' ? 'hidden' : ''}'>{oldPasswordError}</p>
						</div>
						<div class='input'>
							<div class="relative">
								<input id="new-password" name="new_password" type="password" placeholder="New Password" class="peer z-20 placeholder:text-transparent {newPasswordError === '' ? '' : 'border-red-600'}"/>
								<label for="new-password" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">New Password</label>
							</div>
							<p class='error-text {newPasswordError === '' ? 'hidden' : ''}'>{newPasswordError}</p>
						</div>
						<div class='input'>
							<div class="relative">
								<input id="check-new-password" name="check_new_password" type="password" placeholder="Verify New Password" class="peer z-20 placeholder:text-transparent {checkNewPasswordError === '' ? '' : 'border-red-600'}"/>
								<label for="check-new-password" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Verify New Password</label>
							</div>
							<p class='error-text {checkNewPasswordError === '' ? 'hidden' : ''}'>{checkNewPasswordError}</p>
						</div>
						<div class="flex flex-row justify-between">
							<a class="w-2/5 text-lg font-sans" href="/user-info-menu">
								<button class="px-5 pb-2 pt-1 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Back
								</button>
							</a>
							<input type="submit" value="Confirm"
								class="w-2/5 pb-2 pt-1 text-xl !px-0 rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer/>
	</div>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}

</style>